export default {
    loading_: false,
    types_operations :[],
    date_subs: null,
    params:{
        type_operations: null,
        date: null,
    }
}


// WEBPACK FOOTER //
// ./src/modules/clear-erp/state.js